// extracted by mini-css-extract-plugin
module.exports = {"header":"PosHeader_header__bvEev","backButton":"PosHeader_backButton__3_T0s","pageTitle":"PosHeader_pageTitle__2wQrv","pageUpperRightMenu":"PosHeader_pageUpperRightMenu__Ldy8d"};